// Quita de la selección los clips con los ids dados (comparación por string: los ids llegan como string o number).
export const pruneSelection = (rows, ids) => {
  const removed = new Set(ids.map(String));
  return rows.filter((row) => !removed.has(String(row.id)));
};
